// extracted by mini-css-extract-plugin
export default {"addNewCard":"AddNewCard_addNewCard__qflAj","header":"AddNewCard_header__ZULe9","row":"AddNewCard_row__I3hzV","twoItemsRow":"AddNewCard_twoItemsRow__3HJ0O"};